import React from 'react';
import SuperAdminLayout from '../../components/admin/SuperAdminLayout';
import PerformanceAnalytics from '../../components/admin/PerformanceAnalytics';

const PerformancePage: React.FC = () => {
  return (
    <SuperAdminLayout>
      <PerformanceAnalytics />
    </SuperAdminLayout>
  );
};

export default PerformancePage;